const state = {
  author:"jason"
}
const getters = {
  getState: state => {
    return state.productCode
  },
}
export default {
  state,
  getters
}